import type { Market } from "@/lib/useMarket"
import type { QuickViewData } from "./types"
import MarginsCard from "./MarginsCard"
import SummaryCards from "./SummaryCards"
import GraphsSection from "./sections/GraphsSection"
import IncomingSection from "./sections/IncomingSection"
import PriceSection from "./sections/PriceSection"
import SalesSection from "./sections/SalesSection"
import StockByWarehouse from "./sections/StockByWarehouse"
import SupplySection from "./sections/SupplySection"

// The panel's sections, top to bottom, as the spec lists them.
export default function PanelBody({ data, market }: { data: QuickViewData; market: Market }) {
  return (
    <div className="flex flex-col pb-6">
      <MarginsCard margins={data.margins} currency={data.currency} />
      <SummaryCards data={data} />
      <IncomingSection incoming={data.incoming} today={data.today} />
      <GraphsSection data={data} />
      <StockByWarehouse stock={data.warehouse_stock} marketName={market.name} />
      <PriceSection price={data.price} currency={data.currency} />
      <SalesSection sales={data.sales} today={data.today} />
      <SupplySection supply={data.supply} />
    </div>
  )
}
